"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var axios_1 = require("axios");
var PathUtils_1 = require("@twii/core/lib/PathUtils");
var Defaults = {
    baseUrl: "/api",
    auth: undefined
};
var RestImageService = /** @class */ (function () {
    function RestImageService() {
    }
    Object.defineProperty(RestImageService.prototype, "baseUrl", {
        get: function () {
            return this._baseUrl || Defaults.baseUrl;
        },
        set: function (value) {
            this._baseUrl = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(RestImageService.prototype, "auth", {
        // NOTE: this would probably only ever be for server side usage
        get: function () {
            return this._authConfig || Defaults.auth;
        },
        set: function (value) {
            this._authConfig = value;
        },
        enumerable: true,
        configurable: true
    });
    RestImageService.prototype.getImageUrl = function (request) {
        return this.baseUrl + "/image/" + request.id + "/";
    };
    RestImageService.prototype.getImages = function (request) {
        return axios_1.default.get(this.baseUrl + "/image/", { params: request, auth: this.auth }).then(function (value) {
            return value.data;
        });
    };
    RestImageService.prototype.saveImage = function (request) {
        var imageFormData = new FormData();
        imageFormData.append("image", request.file);
        if (request.security_marking) {
            imageFormData.append("security_marking", request.security_marking);
        }
        if (request.image_type) {
            imageFormData.append("image_type", request.image_type);
        }
        imageFormData.append("file_extension", PathUtils_1.extname(request.file.name, true).toLowerCase());
        var imagePromise = request.id ?
            axios_1.default.patch(this.baseUrl + "/image/" + request.id + "/", imageFormData, { auth: this.auth }) :
            axios_1.default.post(this.baseUrl + "/image/", imageFormData, { auth: this.auth });
        return imagePromise.then(function (value) {
            return value.data;
        });
    };
    RestImageService.prototype.deleteImage = function (request) {
        return axios_1.default.delete(this.baseUrl + "/image/" + request.id + "/", { auth: this.auth });
    };
    return RestImageService;
}());
exports.RestImageService = RestImageService;
